import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import { Button } from "../../UI/Button";
import { ResetInvitationsModal } from "./ResetInvitationsModal";

interface IProps {
  name: string;
  invitationId: string;
  isDisabled?: boolean;
}

export const ResetInvitationButton: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();

  const handleInvitationReset = (e: any) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  return (
    <>
      <Button appearance="link" onClick={handleInvitationReset} isDisabled={props.isDisabled}>
        RESET INVITATION
      </Button>
      <ResetInvitationsModal name={props.name} invitationId={props.invitationId} />
    </>
  );
};
